export const chapters = [
  {
    slug: 'umd',
    name: 'Do Quantum @ UMD',
    university: 'UMD',
    logo: '/umd-circle.png',
    group: '/groups/umd-inside.jpg',
    description: 'The founding chapter of Do Quantum, based in College Park, Maryland.',
    chapterExecutive: 'Evren Yucekus-Kissane',
    programsExecutive: 'Wilson Smith',
    established: 'January 2024',
    contactEmail: 'founder@doquantum.org',
    discord: 'https://discord.gg/XG53wCvG2W',
    instagram: 'https://www.instagram.com/doquantumumd/',
    stats: {
      members: 61,
    },
    team: [
      {
        name: 'Evren Yucekus-Kissane',
        division: 'Chapter Leadership',
        role: 'Chapter Executive',
        image: '/evren.JPG',
        linkedin: 'https://www.linkedin.com/in/evrenyk/',
        bio: 'Oversees all chapter operations and works directly with Programs Executive.',
      },      
      {
        name: 'Aaron Robertson',
        division: 'Chapter Leadership',
        role: 'Operational Advisor',
        image: '/aaron.jpg',
        linkedin: 'https://www.linkedin.com/in/aaron-r-0655b811b/',
        bio: 'Supports internal coordination, scheduling, and cross-team logistics.',
      },
      {
        name: 'Currently Open',
        division: 'Chapter Leadership',
        role: 'Chief of Staff',
        image: '/question-mark.webp',
        linkedin: '',
        bio: 'Supports internal coordination, scheduling, and cross-team logistics.',
      },
      {
        name: 'Wilson Smith',
        division: 'Programs Leadership',
        role: 'Programs Executive',
        image: '/wilson.jpg',
        linkedin: 'https://www.linkedin.com/in/wilson-smith-2421a51a2/',
        bio: 'Leads the Programs Division including Research and Training initiatives.',
      },
      {
        name: 'Currently Open',
        division: 'Chapter Leadership',
        role: 'Marketing Lead',
        image: '/question-mark.webp',
        linkedin: '',
        bio: 'Responsible for promoting events and managing social media or outreach materials.',
      },
      {
        name: 'Currently Open',
        division: 'Chapter Leadership',
        role: 'Finance Lead',
        image: '/question-mark.webp',
        linkedin: '',
        bio: 'Handles budgeting, sponsorship coordination, and resource allocation.',
      },
      {
        name: 'Currently Open',
        division: 'Programs Leadership',
        role: 'Research Lead',
        image: '/question-mark.webp',
        linkedin: '',
        bio: 'Coordinates research efforts and supports peer advisors and researchers.',
      },
      {
        name: 'Currently Open',
        division: 'Programs Leadership',
        role: 'Training Lead',
        image: '/question-mark.webp',
        linkedin: '',
        bio: 'Develops and delivers technical training for new researchers.',
      },
      {
        name: 'Evren Yuckeus-Kissane',
        division: 'Research Track Support',
        role: 'Senior Peer Advisor',
        image: '/evren.JPG',
        linkedin: 'https://www.linkedin.com/in/evrenyk/',
        bio: 'Supports peer advisors and oversees researcher progress across research teams.',
      },
      {
        name: 'Wilson Smith',
        division: 'Research Track Support',
        role: 'Peer Advisor',
        image: '/wilson.jpg',
        linkedin: 'https://www.linkedin.com/in/wilson-smith-2421a51a2/',
        bio: 'Mentors researchers in their peer pod and provides weekly support.',
      },   
      {
        name: 'Om Tailor',
        division: 'Research Track Support',
        role: 'Peer Advisor',
        image: '/om.jpg',
        linkedin: 'https://www.linkedin.com/in/om-tailor-02b793226',
        bio: 'Mentors researchers in their peer pod and provides weekly support.',
      },      
      {
        name: 'Vikram Kashyap',
        division: 'Research Track Support',
        role: 'Peer Advisor',
        image: '/vik.png',
        website: 'https://vikramkashyap.com/',
        bio: 'Mentors researchers in their peer pod and provides weekly support.',
      },    
      {
        name: 'Skylar Chan',
        division: 'Research Track Support',
        role: 'Peer Advisor',
        image: '/headshots/SkylarChan.jpg',
        website: 'https://skylarchan.com/',
        bio: 'Mentors researchers in their peer pod and provides weekly support.',
      },
      {
        name: 'Evren Yucekus-Kissane',
        division: 'Chapter Lab Support',
        role: 'Quantum-Chemistry Researcher',
        image: '/evren.JPG',
        linkedin: 'https://www.linkedin.com/in/evrenyk/',
        bio: 'Conducts research intersecting quantum and other domains.',
      },
      {
        name: 'Aryan Mehta',
        division: 'Chapter Lab Support',
        role: 'Quantum-Chemistry Researcher',
        image: '/aryan.webp',
        linkedin: 'https://www.linkedin.com/in/aryanmehta7/',
        bio: 'Conducts research intersecting quantum and other domains.',
      },
      {
        name: 'Siri Duddella',
        division: 'Chapter Lab Support',
        role: 'Quantum-Chemistry Researcher',
        image: '/siri.jpg',
        linkedin: 'https://www.linkedin.com/in/siriduddella/',
        bio: 'Conducts research intersecting quantum and other domains.',
      },
    ]
  },
];
